const Utilities = {
  methods: {
    getPercentage(v1, v2) {
      var value = 0
      if (Number(v2) && v2 > 0) {
        return (v1 / v2) * 100
      }
      return value
    }
  }
}

export default Utilities
